import {v4 as uuidv4} from 'uuid'
import { Command } from './Command'

export class UserMessageCommand extends Command {
    constructor(msg: string, color: string, showLogin: boolean) {
        super()
        this.msg = msg
        this.color = color
        this.showLogin = showLogin
    }
    msg: string
    color: string
    showLogin: boolean
}